import { toPaginate } from '@/utils/infrastructure';
import _, { filter } from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('environments');

import { queryEditActive, queryListPermissions, querySavePermission } from './service';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'environments',
  state: {
    newEnvironment: false,
    newPermission: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    listUserPermission: [],
    listPositionPermission: [],
    listUserGroupPermission: [],
    listAreaPermission: [],
    pagination: meta,
    select: 'id,name,description,isPublic,isActive,isDefault,type',
    notSelectSearch: 'isDefault,isPublic,type',
    searchSelect: ['name', 'description'],
    paramsView: {
      select: 'id,name,description,isPublic,isActive,isDefault,type,updated,created',
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select: 'id,name,description,isPublic,isActive,isDefault,type',
    },
    view: false,
    orderBy: '',
    id: null,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'environment/paged',
          params: payload,
        });
        yield put({
          type: 'queryEnvironments',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *fetchListPermissions({ payload }, { call, put }) {
      try {
        const response = yield call(queryListPermissions, payload);
        yield put({
          type: 'queryPermission',
          payload: {
            data: response,
            name: payload.name,
            field: payload.field,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewEnvironment({ payload }, { put }) {
      yield put({
        type: 'addEnvironments',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewEnvironments',
          payload,
        });
      }
    },

    *saveNewEnvironment({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'environment',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveEnvironment',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *editItemEnvironment({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'environment',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editEnvironments',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *saveEditEnvironment({ payload, params }, { call, put, select }) {
      try {
        const response = yield call(api.update, {
          route: 'environment',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveEnvironment',
          payload: response,
        });

        const currentState = yield select((state) => state.environments);
        const currentPage = currentState.pagination?.page || params.page || 1;
        const finalParams = {
          ...params,
          page: currentPage,
        };

        yield put({
          type: 'fetchList',
          payload: finalParams,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `environment/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'saveEnvironment',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        if (error && error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },

    *setDefault({ payload, id }, { call, put }) {
      try {
        yield call(api.exec, {
          route: `environment/default/${id}`,
          httpMethod: 'post',
        });
        yield put({
          type: 'fetchList',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },

    *showItemUser({ view }, { put }) {
      yield put({
        type: 'showEditItemUser',
        view,
      });
    },

    *addNewPermission({ payload }, { put }) {
      yield put({
        type: 'addPermission',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *addListPermission({ payload }, { put }) {
      yield put({
        type: 'addListPermissions',
        payload,
      });
    },

    *deleteItemPermision({ payload }, { put }) {
      yield put({
        type: 'deleteItemPermisions',
        payload,
      });
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },

    *hideNewPermission({ payload = 'hidePermission' }, { put }) {
      yield put({
        type: payload,
      });
    },

    *savePermission({ payload }, { call, put }) {
      try {
        yield call(querySavePermission, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'addPermission',
          payload: {
            state: false,
            item: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
  },
  reducers: {
    queryEnvironments(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addEnvironments(state, { payload }) {
      return {
        ...state,
        newEnvironment: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newPermission: false,
      };
    },
    editOrViewEnvironments(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    editEnvironments(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newPermission: false,
      };
    },

    saveEnvironment(state, { payload }) {
      return {
        ...state,
        saveEnvironment: payload,
        newEnvironment: false,
        selectedItem: null,
        view: false,
      };
    },

    showEditItemEnvironment(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    addPermission(state, { payload }) {
      return {
        ...state,
        newPermission: payload.state,
        selectedItem: payload.item,
      };
    },

    queryPermission(state, { payload }) {
      return {
        ...state,
        [payload.name]: payload.data,
      };
    },

    addListPermissions(state, { payload }) {
      return {
        ...state,
        [payload.name]: [...state[payload.name], payload.data],
      };
    },

    deleteItemPermisions(state, { payload }) {
      return {
        ...state,
        [payload.name]: _.filter(state[payload.name], (l) => l.id !== payload.id),
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newEnvironment: false,
        selectedItem: null,
        newPermission: false,
        listUserPermission: [],
        listPositionPermission: [],
        listUserGroupPermission: [],
        listAreaPermission: [],
        formConfig: null,
        id: null,
        orderBy: '',
      };
    },

    hidePermission(state) {
      return {
        ...state,
        selectedItem: null,
        newPermission: false,
        listUserPermission: [],
        listPositionPermission: [],
        listUserGroupPermission: [],
        listAreaPermission: [],
        formConfig: null,
        id: null,
      };
    },
  },
};

export default Model;
